import { ItemPickerFeatures as Features } from "../../ItemSelector/types";

type FeatureKey = keyof Features;

type FeatureReturn = { [Prop in FeatureKey]: boolean };

type UseFeatureProps = (
  features: Partial<Features>,
  key: FeatureKey | FeatureKey[],
) => Partial<FeatureReturn>;

export const useFeature: UseFeatureProps = (features, key) => {
  const getFeature: (inputKey: FeatureKey) => FeatureReturn = (inputKey) => {
    const feature = Object.keys(features).includes(inputKey);
    if (feature) {
      return { [inputKey]: features?.[inputKey] || false };
    }
    return { [inputKey]: false };
  };

  return typeof key === "string"
    ? getFeature(key)
    : key.reduce((acc, singleKey) => {
        return {
          ...acc,
          ...getFeature(singleKey),
        };
      }, {});
};
